import React from "react";
import { colorFunctionalGray70, colorMiscGray80, spacingM, spacingS, spacingSm, spacingXs, spacingXxs, } from "@rhumbix/rmbx_design_system_design_tokens";
import styled from "styled-components";
import { formatOptionContent } from "./SelectorOption";
/**
 * The default component for rendering an option in the Selector
 *
 * @param   option  The option to render
 * @param   context The context for this option to pass to the valueFormatter
 * @param   valueFormatter  An instance of a Capn tValueFormatter used to specify the value of the option
 * @param   prefixFormatter An instance of a Capn tValueFormatter that can add a prefix to the text of the option
 * @param   titleFormatter The Capn tValueFormatter that formats the main title of the option. If one is not
 *                          provided, the display resorts to the valueFormatter
 * @param   primarySubtitleFormatter  An instance of a Capn tValueFormatter that displays additional properties of the
 *                          object represented by the option
 * @param   secondarySubtitleFormatter  An instance of a Capn tValueFormatter that displays more additional properties
 *                           of the object represented by the option
 * @returns The rendered option for the selector
 */
const GroupedSelectorOption = props => {
    const { prefix, title, primarySubtitle, secondarySubtitle } = formatOptionContent(props);
    return (React.createElement(StyledOption, { className: "option-content" },
        prefix ? React.createElement(Prefix, null, prefix) : null,
        title ? React.createElement(Title, null, title) : null,
        primarySubtitle ? React.createElement(PrimarySubtitle, null, primarySubtitle) : null,
        secondarySubtitle ? React.createElement(SecondarySubtitle, null, secondarySubtitle) : null));
};
export default GroupedSelectorOption;
const StyledOption = styled.div `
    color: ${colorFunctionalGray70};
    display: grid;
    grid-auto-flow: row;
    grid-row-gap: ${spacingXxs};
    div {
        line-height: ${spacingM};
        margin-bottom: ${spacingXs};
    }
`;
const Prefix = styled.div `
    font-size: ${spacingSm};
`;
const Title = styled.div `
    color: ${colorMiscGray80};
    font-size: 14px;
    font-weight: 500;
    margin-right: ${spacingS};
`;
const PrimarySubtitle = styled.div `
    color: ${colorMiscGray80};
    font-size: ${spacingSm};
    margin-bottom: 0px;
`;
const SecondarySubtitle = styled.div `
    color: ${colorMiscGray80};
    font-size: ${spacingSm};
`;
